jQuery(function () {
  var iframeAPIStatus = "unloaded";

  if (jQuery(".vimeo-player").length) {
    addPlayListeners();
  }

  listenForDynamicallyAddedPlayers();

  function addPlayListeners() {
    if (iframeAPIStatus == "unloaded") {
      addIframeAPI();
    } else if (iframeAPIStatus == "loaded") {
      jQuery(".vimeo-player").each(function () {
        addPlayListener(this);
      });
    }
  }

  function addIframeAPI() {
    iframeAPIStatus = "loading";

    var tag = document.createElement("script");

    tag.onload = function () {
      iframeAPIStatus = "loaded";
      addPlayListeners();
    };

    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function addPlayListener(iframe) {
    if (iframe.playListenerAdded) {
      return;
    }

    var player = new Vimeo.Player(iframe);

    player.on("play", function () {
      player.getVideoTitle().then(function (title) {
        player.getDuration().then(function (duration) {
          jQuery(iframe).trigger("embed:play.sparkle", ["vimeo", title, duration]);
        });
      });
    });

    player.on("pause", function () {
      jQuery(iframe).trigger("embed:pause.sparkle");
    });

    player.on("ended", function () {
      jQuery(iframe).trigger("embed:ended.sparkle");
    });

    iframe.playListenerAdded = true;
  }

  function listenForDynamicallyAddedPlayers() {
    document.addEventListener(
      "load",
      function (e) {
        if (jQuery(e.target).is(".vimeo-player")) {
          addPlayListeners();
        }
      },
      true,
    );
  }
});
